exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TripLaps-155c0b55{margin-bottom:30px}.TripLaps-155c0b55 .eleGain-30b8a212{margin-right:15px}.TripLaps-155c0b55 .distance-8d68a6d0{display:inline-block;width:40px;text-align:right}\n", ""]);

// Exports
exports.locals = {
	"TripLaps": "TripLaps-155c0b55",
	"eleGain": "eleGain-30b8a212",
	"distance": "distance-8d68a6d0"
};